import React, { useEffect } from 'react';
import ExpandCollapse from '../../common/ExpandCollapse';
import GoUpParag from '../../common/GoUpParag';
import MatchBet from '../../common/MatchBet';
import MessageInfo from '../../common/MessageInfo';
import { classIf, getConfiguration, getMatchIdOrStageId, getPrincipaleOPrimoGruppo, iconSportCssClass } from '../../data/utils';
import BetGeniusWidget from '../../data/widgets/BetGeniusWidget';
import FlashbetWidget from '../../data/widgets/FlashbetWidget';
import StatsCoreWidget from '../../data/widgets/StatsCoreWidget';
import { bgWidgetEnabled, brWidgetS5Enabled, getBetgeniustWidgetUrl, getFlashbetWidgetUrl, isWidgetEnabled, statsCoreWidgetEnabled, STATSCORE_WIDGET_LIVESCORE, WidgetContext, getStatsCoreConfigurationId, STATSCORE_WIDGET_PREMATCH_PRO } from '../../data/widgets/WidgetContext';
import { ReactComponent as PinIcon } from '../../icons/pin.svg';
import { ReactComponent as FavoriteWh } from '../../icons/favoriteWh.svg';
import { getLabel } from '../../InitData';
import ButtonsContainer from './ButtonsContainer';
import { PrematchCompetitionContext } from './PrematchHomeCompetitionMacrogruppo';
import Jersey from '../../data/jerseys/Jersey';
import StatsToggle from '../../common/StatsToggle';
import ButtonsContainerAltNew from './ButtonsContainerAltNew';
import { formatDate } from '../../data/parseData48H';
import { useUISettingsDispatch } from '../../UISettingsProvider';
import { systemCode } from '../..';

function CompetitionMacrogruppo(props) {
    const prematchCompetitionContext = React.useContext(PrematchCompetitionContext);
    const widgetContext = React.useContext(WidgetContext);
    const isBrWidgetS5 = brWidgetS5Enabled(props.sportRef, props.widgetType);
    const isBetgeniusWidget = bgWidgetEnabled(props.sportRef, props.widgetType, props.geniusId);
    const isStatsCoreWidget = statsCoreWidgetEnabled(STATSCORE_WIDGET_LIVESCORE, widgetContext.widgetProviderType, props.lsportWidgetId);
    const flashbetWidgetUrl = getFlashbetWidgetUrl(props.widgetType);
    let aggPrincipale = getPrincipaleOPrimoGruppo(props.macrogruppo.aggregate);
    const expandedBets = {};

    function selectFavorites() {
        prematchCompetitionContext.selectFavorites();
    }

    let bets = props.bets;
    // Aggiungi gli id delle scommesse del gruppo principale alla mappa delle scommesse aperte
    bets.forEach(bet => expandedBets[bet.id] = true);
    // Se ci sono scommesse compattate nel gruppo principale,
    // aggiungi anche i loro id tra le scommesse aperte
    if (aggPrincipale.compattate != null) {
        for (let key in aggPrincipale.compattate) {
            const idCompattata = aggPrincipale.compattate[key].join('_');
            expandedBets[idCompattata] = true;
        }
    }

    if (prematchCompetitionContext.favoritesSelected) {
        bets = bets.filter(bet => bet.hasOdds && prematchCompetitionContext.isMarketFavorite(props.sportRef, `${bet.id}_${bet.handicap}`));
    } else {
        bets = bets.filter(bet => bet.hasOdds);
    }
    const betsList = bets.map(function (bet) {
        const betExpanded = prematchCompetitionContext.favoritesSelected || expandedBets[bet.id] !== undefined;
        return (
            <MatchBet key={`${props.id}_${bet.uniqueId}`} {...bet} expanded={betExpanded} showFavoritesToggle={true} />
        );
    });

    useEffect(function () {
        const widgetEnabled = isWidgetEnabled(props.sportRef, props.widgetType, props.geniusId, props.lsportWidgetId);
        if (!props.isLive && widgetEnabled) {
            widgetContext.setWidget({
                widgetGeniusId: props.geniusId,
                widgetLsportId: props.lsportWidgetId,
                widgetProviderType: props.widgetType,
                widgetSportId: props.sportRef,
                widgetMatchId: getMatchIdOrStageId(props),
                widgetContainerId: '#collassaWidgetCompetition',
                widgetStartCollapsed: true
            });
        }

        return function () {
            if (!props.isLiveSuite) {
                widgetContext.setWidget({
                    widgetMatchId: null
                });
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.isLive, props.id]);

    const icoSport = iconSportCssClass(props.sportRef, props.iconClass);
    const showFavorites = prematchCompetitionContext.showFavoritesForSport(props.sportRef);
    const conf = getConfiguration();

    const macrogruppiBtns = props.macrogruppi.map((mg, i) => {
        function handleClick() {
            props.setMacrogruppo(mg);
        }
        const selected = !prematchCompetitionContext.favoritesSelected && props.macrogruppo != null && props.macrogruppo.id === mg.id;
        return (
            <React.Fragment key={mg.id} >
                {showFavorites && i === 0 &&
                    <div className={"bordo-tondo elemento-macro pointer elementoDropdown" + classIf(prematchCompetitionContext.favoritesSelected, 'icona-selezionata')} onClick={selectFavorites}>
                        {getLabel('favorite_markets')}
                        {conf.iwh ? <FavoriteWh className="favorite-icon" ></FavoriteWh>
                            :
                            <PinIcon className="pin-icon ml-2"></PinIcon>
                        }
                    </div>
                }
                <div data-id={`m-${mg.id}`} className={"bordo-tondo elemento-macro pointer elementoDropdown" + classIf(selected, 'icona-selezionata')} onClick={handleClick}>{mg.descrizione}</div>
            </React.Fragment >
        );
    });

    const macrogruppiMaxNumOfRows = 3; //3
    const dispatch = useUISettingsDispatch();

    function handleFullScreen() {
        dispatch({type: 'toggleFullscreen'});
    }

    return (
        <>
            <div className="titolo-blocco-sport titolo-con-data bg-nero bianco">
                <div className="d-flex justify-content-between align-items-center w-100" >
                    {props.isLive &&
                        <div className={`img-fluid ico-sport mr-1 ${icoSport}`}></div>
                    }
                    <div className="d-flex flex-column">
                        <div className="d-flex items-center">
                            {props.team2 &&
                                <Jersey data={props.jerseys?.[0]} type={'home'} sportRef={props.sportRef} />
                            }
                            <p className="nome-partita-sport">{props.team1}</p>
                        </div>
                        {props.team2 &&
                            <div className="d-flex items-center">
                                <Jersey data={props.jerseys?.[1]} type={'away'} sportRef={props.sportRef} />
                                <p className="nome-partita-sport">{props.team2}</p>
                            </div>
                        }
                    </div>
                    <div className="data-orario-partita-sport d-flex justify-content-end align-items-center margine-sx">
                        {conf.iwh ? <div>{formatDate(props.timestampDB)} {props.time}</div> : <div>{props.date} {props.time}</div>}
                        <StatsToggle className="fas fa-chart-bar stat-sel margine-sx-mezzo grigio pointer" match={props} />
                       {systemCode === 'STARCASINO' && <i className='close--sidebar fa fa-times' onClick={handleFullScreen}></i>}
                    </div>
                </div>
            </div>
            {widgetContext.widgetMatchId != null && widgetContext.widgetMatchId >= 0 && widgetContext.widgetContainerId === '#collassaWidgetCompetition' &&
                <div className={`widget-filtro-side margine-giu live-tracker-widget ${isBetgeniusWidget ? 'betgeniusWidget' : ''}`}>
                    {flashbetWidgetUrl ?
                        <FlashbetWidget url={flashbetWidgetUrl} />
                        :
                        isBetgeniusWidget ?
                            <BetGeniusWidget url={getBetgeniustWidgetUrl(props.sportRef, props.categoryRef, props.tournamentRef)} />
                            :
                            isStatsCoreWidget ?
                                <StatsCoreWidget />
                                :
                                <div className={`bordato-widget bg-nero${isBrWidgetS5 ? ' brWidgetS5' : ''}`} id="collassaWidgetCompetition"></div>
                    }
                </div>
            }
            {props.giocabilita !== undefined && !props.giocabilita ?
                <MessageInfo message={getLabel('general.giocabilita_chiusa')} />
                :
                <>
                    {(showFavorites || (props.macrogruppi && props.macrogruppi.length > 1)) &&
                        <div className="macro-gruppi">
                            {macrogruppiMaxNumOfRows <= 0 ?
                                <div className="parentDropdown box-grid-2 paddles-buttons-2">
                                    <div className="containerElementiDropdown horiz-sc icons-container force-grid-view elenco-macro">
                                        {showFavorites &&
                                            <div className={"bordo-tondo elemento-macro pointer elementoDropdown" + classIf(prematchCompetitionContext.favoritesSelected, 'icona-selezionata')} onClick={selectFavorites}>
                                                {getLabel('favorite_markets')}
                                                <PinIcon className="pin-icon ml-2"></PinIcon>
                                            </div>
                                        }
                                        {props.macrogruppi.map(function (mg, i) {
                                            function handleClick() {
                                                props.setMacrogruppo(mg);
                                            }
                                            const selected = !prematchCompetitionContext.favoritesSelected && props.macrogruppo != null && props.macrogruppo.id === mg.id;
                                            return <div key={i} className={"bordo-tondo elemento-macro pointer elementoDropdown" + classIf(selected, 'icona-selezionata')} onClick={handleClick}>{mg.descrizione}</div>
                                        })}
                                    </div>
                                </div>
                                :
                                (conf.iwh ?
                                    (macrogruppiBtns.length > 1 &&
                                        <ButtonsContainerAltNew id={props.macrogruppo.id} buttons={macrogruppiBtns} aggregate={false} maxNumOfRows={macrogruppiMaxNumOfRows} scrollOffset={150} />
                                    )
                                    /* ALTRIMENTI DI DEFAULT MOSTARMI QUESTO SOTTO PRECEDENTE */
                                    : (macrogruppiBtns.length > 1 &&
                                        <ButtonsContainer id={props.macrogruppo.id} buttons={macrogruppiBtns} aggregate={false} maxNumOfRows={macrogruppiMaxNumOfRows} scrollOffset={150} />
                                    ))
                            }
                        </div>
                    }
                    {prematchCompetitionContext.favoritesSelected && betsList.length === 0 ?
                        <div className="text-center">{getLabel('favorite_markets.add_markets')}</div>
                        :
                        <>
                            <ExpandCollapse key={`expand-collapse-${props.macrogruppo.id}`} />
                            <div className="blocco-quote-espanse">
                                <div className="colonne-evento-live d-grid unaColonna">
                                    {betsList}
                                </div>
                            </div>
                        </>
                    }
                    <GoUpParag />
                </>
            }
        </>
    );
}

export default CompetitionMacrogruppo;